import { lazy } from 'react';

import type { RouteConfig } from '../../types';

// Lazy load layouts
const DashboardLayout = lazy(() => import('@/layouts/DashboardLayout'));

// Lazy load velocity forecast pages
const VelocityForecastPage = lazy(() => import('@/pages/velocity-forecast'));
const CreateVelocityForecastPage = lazy(() => import('@/pages/velocity-forecast/create'));

/**
 * Velocity Forecast routes
 * Handles velocity forecast management
 */
export const velocityForecastRoutes: RouteConfig = {
  path: '/velocity-forecast',
  layout: DashboardLayout,
  children: [
    {
      path: '',
      element: VelocityForecastPage,
    },
    {
      path: '/create',
      element: CreateVelocityForecastPage,
    },
  ],
};
